module.exports = __webpack_public_path__ + "media/images/easy-steps-1-6b782219bb57c20147ef96104ba78c7f.jpeg";